import service from "@irati/utils/tracking/index";
var tracking = {
    editProfile: function () {
        service.trackEvent("admin_dashboard_edit_profile");
    },
    viewPeople: function () {
        service.trackEvent("admin_dashboard_view_people");
    },
    addSinglePerson: function () {
        service.trackEvent("admin_dashboard_add_single");
    },
    addBulkPeople: function () {
        service.trackEvent("admin_dashboard_add_bulk");
    },
    viewTeams: function () {
        service.trackEvent("admin_dashboard_view_teams");
    },
    addTeam: function () {
        service.trackEvent("admin_dashboard_add_team");
    },
    viewCustomisation: function () {
        service.trackEvent("admin_dashboard_view_customisation");
    },
    updateBrand: function () {
        service.trackEvent("admin_dashboard_update_brand");
    },
    addBenefit: function () {
        service.trackEvent("admin_dashboard_add_benefit");
    },
    perkVisibility: function () {
        service.trackEvent("admin_dashboard_perk_visibility");
    },
    viewRoles: function () {
        service.trackEvent("admin_dashboard_view_roles");
    },
    recognitionPermissions: function () {
        service.trackEvent("admin_dashboard_recognition_permissions");
    },
    viewLogin: function () {
        service.trackEvent("admin_dashboard_view_login");
    },
    enableSignUp: function () {
        service.trackEvent("admin_dashboard_ssu");
    },
    setUpSingleSignOn: function () {
        service.trackEvent("admin_dashboard_sso");
    },
    viewReports: function () {
        service.trackEvent("admin_dashboard_view_reports");
    },
    viewHelp: function () {
        service.trackEvent("admin_dashboard_view_help");
    }
};
export default tracking;
